module.exports = __webpack_public_path__ + "static/forecast/weather/dayheavysnow-080b14ea1a49307535d923edf8ecd9dc.svg";